
<router-outlet></router-outlet>
<!-- <div class="app-container" [ngClass]="isDarkMode ? 'dark-theme' : 'light-theme'">
  <app-sidebar></app-sidebar>
  <app-chat></app-chat>
</div> -->

